import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "vue-megamenu-navbar" }
const _hoisted_2 = ["index"]
const _hoisted_3 = ["href", "onMouseenter", "onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  class: "vue-megamenu-submenu",
  ref: "submenu"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "vue-megamenu-submenu__inner" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "vue-megamenu-button" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-dot-3" })
], -1)
const _hoisted_11 = { class: "vue-megamenu-submenu__inner__links" }
const _hoisted_12 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_container = _resolveComponent("container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (category, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["vue-megamenu__section", { active: _ctx.activeCategory === category && _ctx.isOpen}]),
        index: index,
        key: category.id
      }, [
        _createElementVNode("a", {
          href: _ctx.addStoreToUrl(category.url, _ctx.storeTitle),
          class: _normalizeClass(["vue-megamenu__section__link", { active: _ctx.activeCategory === category && _ctx.isOpen}]),
          onMouseenter: ($event: any) => (_ctx.mouseenter(category)),
          onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mouseleave($event))),
          onClick: _withModifiers(($event: any) => (_ctx.click(category, $event)), ["stop"])
        }, [
          (category.image)
            ? (_openBlock(), _createElementBlock("picture", _hoisted_4, [
                _createElementVNode("img", {
                  src: category.image.replace(/(.jpg|.png)/, '_ew40_ew40.webp'),
                  width: "40",
                  height: "40",
                  loading: "lazy"
                }, null, 8, _hoisted_5)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", null, _toDisplayString(category.name), 1)
        ], 42, _hoisted_3),
        _createElementVNode("a", {
          href: category.url,
          class: "vue-megamenu__section__categories-all vue-megamenu-arrow"
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("megamenu.allCategories")), 1)
        ], 8, _hoisted_6),
        (_openBlock(), _createBlock(_component_container, {
          category: category,
          links: _ctx.links.bottom[category.id] ? _ctx.links.bottom[category.id] : undefined,
          isActive: _ctx.activeCategory === category && _ctx.isOpen,
          key: category.id
        }, null, 8, ["category", "links", "isActive"]))
      ], 10, _hoisted_2))
    }), 128)),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links.button, (link, index) => {
        return (_openBlock(), _createElementBlock("a", {
          key: index,
          class: "vue-megamenu-button vue-megamenu-arrow-mobile",
          href: _ctx.addStoreToUrl(link.url, _ctx.storeTitle)
        }, _toDisplayString(link.title), 9, _hoisted_8))
      }), 128)),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links.submenu, (link, index) => {
              return (_openBlock(), _createElementBlock("a", {
                key: index,
                class: "vue-megamenu-arrow-mobile",
                href: _ctx.addStoreToUrl(link.url, _ctx.storeTitle)
              }, _toDisplayString(link.title), 9, _hoisted_12))
            }), 128))
          ])
        ])
      ])
    ], 512)
  ]))
}